import React from 'react'

import { compose } from '@cbgms/base/utils/compose'
import { connect } from 'react-redux'

import SupportListWrapper from 'core/page/SupportListWrapper'
import { inviteShopEmployee, loadListShopEmployees } from 'app-support/employees/state/actions'
import navigation from 'utils-support/navigation'

interface IOwnProps {
  currentUrl: string
  companyUUID: string
  shopID: string | undefined
}

const enhanced = compose<IOwnProps, IOwnProps>(connect(undefined, { loadListShopEmployees, inviteShopEmployee }))

const onAdd = (companyUUID: string, shopID: string) => () => {
  navigation.push(`/companies/${companyUUID}/shops/${shopID}/employees/new`)
}

const onEdit = (companyUUID: string, shopID: string) => (row: any) => {
  navigation.push(`/companies/${companyUUID}/shops/${shopID}/employees/edit/${row.Employee.UUID}`)
}

const loadFilteredListShopEmployees = (companyUUID: string) => (params: any) => {
  return loadListShopEmployees({
    ...params,
    search: params.search ? [`Employee.CompanyUUID|=|${companyUUID}`, params.search].join(',') : `Employee.CompanyUUID|=|${companyUUID}`
  })
}

export const Employees: React.FC<IOwnProps> = (props: IOwnProps) => {
  /*
    Shop ID can be empty on new shop.
    But you can already add employees.
    To support this just send in 'new' as string.
  */
  const shopID = props.shopID || 'new'

  return (
    <SupportListWrapper
      scope='employees'
      onAdd={onAdd(props.companyUUID, shopID)}
      onEdit={onEdit(props.companyUUID, shopID)}
      loadAction={loadFilteredListShopEmployees(props.companyUUID)}
      translationKey='employees'
    />
  )
}

Employees.displayName = 'Employees'

export default enhanced(Employees)
